import { nextFrame } from "./timing_helpers"

export function getMetaContent(name) {
  return document.querySelector(`meta[name="${name}"]`)?.content
}

export function csrfParam() {
  return getMetaContent("csrf-param") || ""
}

export function csrfToken() {
  return getMetaContent("csrf-token") || ""
}

export function normalizeHTML(html = "") {
  const { body } = new DOMParser().parseFromString(html, "text/html")
  // Remove empty elements
  for (const element of body.querySelectorAll(":not(br,hr,input,img):empty")) {
    element.remove()
  }
  // Normalize task lists
  for (const checkbox of body.querySelectorAll("li > [type=checkbox]")) {
    const li = checkbox.closest("li")
    const ul = li.closest("ul")
    li.setAttribute("data-checked", checkbox.checked)
    li.setAttribute("data-type", "taskItem")
    ul.setAttribute("data-type", "taskList")
  }
  // Convert headings to <p><strong>…</strong></p>
  for (const heading of body.querySelectorAll("h1,h2,h3,h4,h5,h6")) {
    const strong = createElement("strong")
    strong.append(...heading.childNodes)
    const p = createElement("p")
    p.append(strong)
    heading.replaceWith(p)
  }
  // Remove insignificant newlines before opening tags and after closing tags
  return body.innerHTML.replace(/\n</g, "<").replace(/>\n/g, ">")
}

export const escapeHTML = (() => {
  const element = document.createElement("div")
  return (string = "") => {
    element.textContent = string
    return element.innerHTML
  }
})()

export const stripHTML = (() => {
  const element = document.createElement("div")
  return (html = "") => {
    element.innerHTML = html
    return element.textContent
  }
})()

export function domReady(callback = noop) {
  return new Promise((resolve) => {
    const ready = () => {
      callback()
      resolve()
    }
    if (document.readyState == "loading") {
      addEventListener("DOMContentLoaded", ready, { once: true })
    } else {
      ready()
    }
  })
}

export function nextIntersect(element, options = {}) {
  return new Promise((resolve) => {
    new IntersectionObserver(([entry], observer) => {
      if (!entry.isIntersecting) return
      observer.unobserve(element)
      observer.disconnect()
      resolve()
    }, options).observe(element)
  })
}

export function replaceElementWithResponse(element, response) {
  return response.ok
    ? response.text().then((html) => nextFrame().then(() => (element.outerHTML = html)))
    : alert(`Sorry, something went wrong. Reloading the page may help.\n\n(Status: ${response.status})`)
}

export function createElement(tagName, properties = {}) {
  return Object.assign(document.createElement(tagName), properties)
}

export function toggleMultipleClasses(element, options, ...classes) {
  return classes.map((className) => element.classList.toggle(className, options))
}

export function dispatchInputEvent(element) {
  return element.dispatchEvent(new Event("input", { bubbles: true }))
}

export function clickSubmitter(form) {
  const submitter = [...form.elements].find((e) => e.type == "submit" && !e.disabled)
  if (submitter) submitter.click()
  return Boolean(submitter)
}

export const submitForm =
  "requestSubmit" in HTMLFormElement.prototype
    ? (form) => form.requestSubmit()
    : (form) => form.appendChild(createElement("button")).click()

function noop() {}
